import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form } from 'antd';
import { WAREHOUSE_ROUTES } from 'constants/routes';
import { WarehouseAuthContainer } from '../components/WarehouseAuthContainer';
import { SignInForm } from 'components/auth';
import { useWarehouseLoginMutation, useAuthenticateMutation } from '../../../../api';
import { FormProps, notification } from '../../../../components';
import { ErrorMappingValueType } from '../../../../typings';
import { AdminSignInFieldType } from '../../../../typings/auth';
import { useEffect } from 'react';

export const WarehouseSignIn: React.FC = () => {
  const [signIn, { isLoading }] = useWarehouseLoginMutation();
  const [authenticate] = useAuthenticateMutation();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  // Call authenticate API on mount (same as ERP)
  useEffect(() => {
    authenticate();
  }, [authenticate]);

  const [notificationApi, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({
        message: message,
      });
    },
    [notificationApi]
  );

  const onFinish: FormProps<AdminSignInFieldType>['onFinish'] = useCallback(
    (values: AdminSignInFieldType) => {
      signIn(values)
        .then(({ data, error }: any) => {
          if (data?.success) {
            navigate(WAREHOUSE_ROUTES.inboundPackages);
          } else {
            if (data) {
              Object.keys(data).forEach((_key: string) => {
                if (_key === 'response_code' || _key === 'Unauthorized') {
                  openNotificationWithIcon({ type: 'error', message: 'Email or password is invalid!' });
                } else {
                  _key &&
                    openNotificationWithIcon({
                      type: 'error',
                      message: data[_key],
                    });
                }
              });
            } else if (error?.data) {
              openNotificationWithIcon({
                type: 'error',
                message: 'Something went wrong!',
              });
            }
          }
        })
        .catch((err) => {
          console.log(err, 'error');
          openNotificationWithIcon({
            type: 'error',
            message: 'Something went wrong!',
          });
        });
    },
    [signIn, openNotificationWithIcon, navigate]
  );

  const handleForgotPassword = () => {
    navigate(WAREHOUSE_ROUTES.warehouseForgotPassword);
  };

  return (
    <>
      {contextHolder}
      <WarehouseAuthContainer title="Sign In" bottomLinkText="Log in into ERP System" showERPLink={true}>
        <SignInForm
          form={form}
          onFinish={onFinish as any}
          loading={isLoading}
          onForgotPassword={handleForgotPassword}
          submitButtonText="Sign In"
          forgotPasswordText="Forgot password?"
        />
      </WarehouseAuthContainer>
    </>
  );
};
